module.exports = __webpack_public_path__ + "static/img/5.63b8072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/5.png
// module id = qksD
// module chunks = 0